// productHotelApi.js
import axios from "axios";
import querystring from "querystring";
import { getUserData, configFetch } from "./config";

const HOSTNAME = process.env.REACT_APP_API_URL || "http://localhost:8080";

const API_SERVICES = {
  ProductHotelIndex: `${HOSTNAME}/producthotel/index`,
  ProductHotelAdd: `${HOSTNAME}/producthotel/add`,
  ProductHotelEdit: `${HOSTNAME}/producthotel/edit`,
  ProductHotelUpdate: `${HOSTNAME}/producthotel/update`,
  ProductHotelDelete: `${HOSTNAME}/producthotel/delete`,
};

// Function to fetch hotel products
export const fetchProductHotel = async (params) => {
  try {
    const userData = getUserData();
    const url = `${API_SERVICES.ProductHotelIndex}?${querystring.stringify(
      params
    )}`;

    const response = await axios(
      configFetch(url, "get", null, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching hotel products:", error.message);
    throw error;
  }
};

// Function to add a hotel product
export const addProductHotel = async (data) => {
  try {
    const userData = getUserData();
    const currentDate = new Date().toISOString().split("T")[0];

    const payload = {
      ...data,
      id_company: 16,
      id_branch: 56,
      id_user: userData.userId,
      user_submit: userData.nameUser,
      tgl_data: currentDate,
      tgl_valid: currentDate,
    };

    const response = await axios(
      configFetch(API_SERVICES.ProductHotelAdd, "post", payload, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error adding hotel product:", error.message);
    throw error;
  }
};

// Function to update a hotel product
export const updateProductHotel = async (data) => {
  try {
    const userData = getUserData();
    const url = `${API_SERVICES.ProductHotelUpdate}`;
    const currentDate = new Date().toISOString().split("T")[0];

    const payload = {
      ...data,
      id_user: userData.userId,
      user_submit: userData.nameUser,
      tgl_data: currentDate,
      tgl_valid: currentDate,
    };

    const response = await axios(
      configFetch(url, "put", payload, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error updating hotel product:", error.message);
    throw error;
  }
};

// Function to delete a hotel product
export const deleteProductHotel = async (id) => {
  try {
    const userData = getUserData();
    const url = `${API_SERVICES.ProductHotelDelete}`;
    await axios(
      configFetch(url, "delete", id, false, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
  } catch (error) {
    console.error("Error deleting hotel product:", error.message);
    throw error;
  }
};
